import React from "react";

const Commontitle = (props) => {
  return <h2>{props.name}</h2>;
};

export default Commontitle;
